<template>
  <div>
    <client-list
      title="Lista mieszkańców"
      :users="list"
      :count="count"
      @add="showAddModal"
      @delete="showDeleteDialog"
    />

    <modal :show="showModal" @close="hideModal" @save="add" @update="update" />

    <material-dialog
      title="Potwierdź usunięcie"
      :show="!!idToDelete"
      :id="idToDelete"
      :text="confirmDeleteText"
      @close="hideDeleteDialog"
      @confirm="remove"
    />
  </div>
</template>

<script>
import MaterialDialog from '@/components/material/Dialog';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';
import { DEFAULT_LIST_COUNT } from '@/utils/constants';
import Modal from './modals/Profile.modal.vue';
import ClientList from './subViews/ClientList';

/**
 * @vuese
 * @group client
 * Lista klientów
 */
export default {
  components: { MaterialDialog, Modal, ClientList },
  mixins: [
    listMixin('client', {
      listError: 'Wystąpił błąd podczas pobierania listy klientów.',
      getError: 'Wystąpił błąd podczas pobierania danych klienta.',
      added: 'Dodano klienta.',
      addError: 'Nie udało się dodać klienta.',
      updated: 'Zaktualizowano dane klienta.',
      updateError: 'Nie udało się zaktualizować danych klienta.',
      deleted: 'Usunięto klienta.',
      deleteError: 'Nie udało się usunąć klienta.'
    })
  ],
  computed: {
    toDelete() {
      if (this.idToDelete) {
        return this.list.find(item => item.id === this.idToDelete);
      }
    },
    confirmDeleteText() {
      if (this.toDelete) {
        return `Czy na pewno chcesz usunąć konto klienta ${this.toDelete.firstName} ${this.toDelete.lastName}?`;
      }
      return '';
    }
  }
};
</script>
